import React,{useState,useEffect} from 'react'
import { Route, BrowserRouter as Router, Routes, Link, NavLink } from 'react-router-dom';
import { IntrigrationLeftSec } from '../components/intrigrationLeftSec';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from "react-scroll-to-top";
import config from '../Config';

import { IntegrantionModuleService } from '../services/IntegrantionModuleService';

interface IState {
    loading: boolean;
    module: any;
    errorMsg: string;
  }

export const IntegrationsPrestaShopSec = () => {

    const [state, setState] = useState<IState>({
        loading: false,
        module: [] as any,
        errorMsg: "",
    });

    //network request
    useEffect(() => {
        setState({ ...state, loading: true });
        IntegrantionModuleService.getModuleDetails('PrestaShop')
        .then((res) =>{
        setState({
            ...state,
            loading: false,
            module: res.data as any,
        })

        }
        
        )
        .catch((err) =>{
        setState({
            ...state,
            loading: false,
            errorMsg: err.message,
        })

        }
        );
    //eslint-disable-next-line
    }, []);


    const { loading, module, errorMsg } = state;
    const modDetails = module.response?.module_details;
    const latestVersion = module.response?.module_details.length > 0 ? module.response.module_details[0] : [];
    const contentDetArr = module.response?.module_details.length > 0 ? module.response.module_details[0].jsoncontent : [];

    return (
        <>
            <section className="credit-api-main">
                <img src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bg.svg`} alt="" className='apibg' />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <IntrigrationLeftSec />
                        </div>
                        <div className="col-lg-9">
                            <div className="creadit-api-upper-wrapper">
                                <Link to="/integrations" className='apidetail-btn'><FontAwesomeIcon icon={faArrowRight} /> Return to Integrations page</Link>
                                <h1>PrestaShop</h1>

                                <ul className="card-url">
                                    {Object.entries(contentDetArr).map(([keyName, keyValue]: [any, any]) => (
                                        <>
                                        <li>
                                            <div className="card-url-list">
                                                <p>{keyName}:</p>
                                                <span>{keyValue}</span>
                                            </div>
                                        </li>
                                        </>
                                    ))}
                                </ul>
                                <p className='mt-30'>This plugin allows you to use TCB Pay payment portal for your PrestaShop.</p>
                            </div>

                            <div className="creadit-api-lower-wrapper">
                                <div className="api-menu-item-wrapper">
                                    <h3>Installation</h3>
                                    <hr />
                                    {latestVersion.download_url && latestVersion.file_name &&
                                        <Link to={`${config.pluginModuleUrl}/${latestVersion.download_url}/${latestVersion.file_name}`} target='_blank' className="integration-btn1 mb-20">Download the PrestaShop extension package <FontAwesomeIcon icon={faArrowRight} /></Link>
                                    }
                                    
                                    {modDetails?.length > 1 &&
                                        <>
                                            <p>Download older versions of the package:</p>
                                            <div className="listintri">
                                                <ul>
                                                {modDetails?.map((keyName: any) => (
                                                    <>
                                                        <li>Download <Link to={`${config.pluginModuleUrl}/${keyName.download_url}/${keyName.file_name}`} target='_blank'>{keyName.version_name}</Link> 
                                                        {keyName.dependency ? `for ${keyName.dependency}` : ""}</li>
                                                    </>
                                                    ))
                                                }
                                                </ul>
                                            </div>
                                        
                                        </>
                                    }
                                </div>
                            </div>

                            <div className="example-box-wrapper mt-30 mb-30">
                                <div className="d-flex align-items-start">
                                    <b>1 </b>
                                    <p>Navigate to the <strong>Modules</strong> menu and click on the <strong>Module Manager</strong> button. You would be redirected to the <strong>Modules management</strong> screen.</p>
                                </div>
                            </div>

                            <div className="example-box-wrapper mb-30">
                                <div className="d-flex align-items-start">
                                    <b>2 </b>
                                    <p>Click on the <strong>Upload a Module</strong> button to proceed with the installation. A new pop-up would appear. You may either drop the module’s .zip file in that pop-up or use the select file link to browse for that module.</p>
                                </div>
                            </div>

                            <img src={`${config.siteBaseUrl}/assets/imgs/tcb_prestashop-1.png`} alt='' />

                            <div className="api-menu-item-wrapper mt-60">
                                <h3>Manage Plugin</h3>
                                <hr />
                                <p>A new pop-up will appear with the message <strong>Module Installed!</strong> That’s it—your module is now successfully installed. You can click the <strong>Configure</strong> button to customize the options for the newly installed module.</p>
                                <p>In the configure screen you can set the following values:</p>
                                <div className='listintri'>
                                    <ul>
                                        <li><strong>Enable:</strong> If Yes then this payment method appears on your cart page as a payment option.</li>
                                        <li><strong>Test Mode:</strong> If Yes account turned into debug mode</li>
                                        <li><strong>Merchant Username:</strong> This is the username provided by TCB Pay when you signed up for an account.</li>
                                        <li><strong>API Key:</strong> This is the API Key provided by TCB Pay when you signed up for an account.</li>
                                        <li><strong>Credit Card Type:</strong> Choose card type from the dropdown</li>
                                        <li><strong>Use CVV:</strong> Choose Yes to use CVV</li>
                                    </ul>
                                </div>
                                <img src={`${config.siteBaseUrl}/assets/imgs/tcb_prestashop.png`} alt='' />
                            </div>

                        </div>
                    </div>
                </div>
                <img src={`${config.siteBaseUrl}/assets/imgs/blue-lowerdots.svg`} alt="" className="orng-dots" />

                <ScrollToTop smooth />
            </section>
        </>
    )
}
